import BaseService from "./BaseService";

export default class JobService extends BaseService {
    getAll() {
        const request = this.requester.get(`${this.url}/api/job`, this.config).then(response => response).catch(e => {
            throw e
        }).finally(() => {
        })
        return request;
    }

    getById(param) {
        const request = this.requester.get(`${this.url}/api/job/${param}`, this.config).then(response => response).catch(e => {
            throw e
        }).finally(() => {
        })
        return request;
    }

    new(param) {
        const request = this.requester.post(`${this.url}/api/job`, param, this.config).then(response => response).catch(e => {
            throw e
        }).finally(() => {
        })
        return request;
    }

    update(param, id) {
        const request = this.requester.post(`${this.url}/api/job/${id}`, param, this.config).then(response => response).catch(e => {
            throw e
        }).finally(() => {
        })
        return request;
    }

    remove(id) {
        const request = this.requester.delete(`${this.url}/api/job/${id}`, {}, this.config).then(response => response).catch(e => {
            throw e
        }).finally(() => {
        })
        return request;
    }
}
